import type { AuthSessionEventType } from '@/constants/auth';

let authSessionChannel: BroadcastChannel | undefined;

export function publishAuthSessionEvent(type: AuthSessionEventType): void {
    getAuthSessionChannel()?.postMessage(type);
}

export function getAuthSessionChannel(): BroadcastChannel | undefined {
    if (!import.meta.client || typeof BroadcastChannel === 'undefined') {
        return undefined;
    }

    authSessionChannel ??= new BroadcastChannel('estimator-auth-session');

    return authSessionChannel;
}
